(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('productSettingMc', {
        templateUrl: 'views/components/views/productSettingMc/productSettingMc.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'productSettingMcService', function ($stateParams, stateService, utilityService, modalService, translateService, productSettingMcService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let productSettingKeyno = $stateParams.productsetting_keyno;
            let productSettingMcKeyno = $stateParams.productsettingmc_keyno;

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };
            
            vm.model = {
                productSettingMcKeyno: productSettingMcKeyno,
                edit: {},
                selectListMetaColumns: [],
                productSettingMcItems: [],
                productSettingMcItemsDefault: [],
                lockedSave: false,
                lockedDelete: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadEdit() {
                vm.model.edit = (await productSettingMcService.getEdit({
                    productsetting_keyno: productSettingKeyno,
                    productsettingmc_keyno: productSettingMcKeyno
                }))[0];

                return Promise.all([
                    loadMetaColumns(),
                    loadProductSettingMcItems()
                ]).then(() => Promise.resolve());

                return Promise;
            }

            async function loadMetaColumns() {
                if (utilityService.validateParmsValue(vm.model.edit.productsetting_keyno) !== true) return;

                return vm.model.selectListMetaColumns = await productSettingMcService.listMetaColumns({ productsetting_keyno: vm.model.edit.productsetting_keyno });
            }

            async function loadProductSettingMcItems() {
                return vm.model.productSettingMcItems = await productSettingMcService.listProductSettingMcItems({ productsettingmc_keyno: vm.model.edit.productsettingmc_keyno });
                
                vm.model.productSettingMcItemsDefault = [{
                    productsettingmcitem_keyno: 0,
                    productsettingmcitem_name: '',
                    item_id: 0,
                    item_name: '',
                    orderby: 0
                }];

                vm.model.productSettingMcItemsDefault.push(...vm.model.productSettingMcItems);
            }
            
            // #endregion LOAD PROCEDURE FUNCTION CALLS

            vm.onChange = function (key, value) {
                vm.model.edit[key] = value;

                if (key === 'metacolumn_keyno') {
                    vm.model.edit.elementtype = vm.model.selectListMetaColumns.find(e => e.metacolumn_keyno === value)?.elementtype;
                }
            }
            
            // #region BUTTON SAVE PROCEDURE FUNCTION CALL
            
            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                productSettingMcService.saveObj(vm.model.edit).then(function (response) {
                    if (response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(function () {
                    productSettingMcService.deleteItem(vm.model.edit).then(function (response) {
                        if (response[0].errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: translations.error,
                                message: response[0].errormessage,
                                buttons: [{
                                    label: translations.ok,
                                    cssClass: 'btn-warning',
                                    action: function (dialogItself) {
                                        dialogItself.close();
                                        vm.model.lockedDelete = false;
                                    }
                                }]
                            });
                        } else {
                            vm.model.lockedDelete = false;
                            stateService.back();
                        }
                    }, function() {
                    	vm.model.lockedDelete = false;
                    });
                }, function () {
                    vm.model.lockedDelete = false;
                });
            };

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
            	loadEdit();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
